import {base64ToBlob, doGet, doPost, doPut} from "./api.js";

import URLSearchParams from '@ungap/url-search-params'

export const API_ENTRY = 'https://editor.flyerline.ch/';
export class PackingAPI {
    /**
     * 
     * @param {string} model
     * @param {string} customer
     * @param {string} jwt
     */
    constructor(model, customer) {
        this.model = model;
        this.customer = customer;
    }

    setModel(model){
        this.model = model;
    }

    getPdf (data, filename = 'print.pdf') {
        let params = {...data};
        params['filename'] = filename;
        params['return_type'] = 'download';
        return this.get('packing/getPdf', params, true);
    }

    uploadPdf(file, conf) {
        const formData = new FormData();

        for (const prop of Object.keys(conf)) {
            if (typeof conf[prop] === 'object') {
                formData.append(prop, JSON.stringify(conf[prop]))
            } else {
                formData.append(prop,conf[prop]);
            }
        }

        formData.append("model", this.model)
        formData.append("pdf", file, file.name )

        return doPost(`${API_ENTRY}packing/uploadPdf`, formData)
            .then(response => {
                return response;
            })
            .catch(xhr=>console.log(xhr));
    }

    /*
        data = {
            Height: <integer>,
            Width: <integer>,
            Length: <integer>
        }
    */
    getPersonalization (data = {}, locale = 'de_CH', configUrlParam, customizedProductId = null) {
        let params = {...data};

        params.packagingOptions = {
            model: this.model,
            In_Designer: 1,
            Use_Bleed_Mask: 1,
            ...data
        }

        let productDetailUrl = window.location.href.split('?')[0]+"?"+configUrlParam;
        params.success_url = productDetailUrl;
        params.cancel_url = productDetailUrl;
        params.customer = this.customer;
        params.template_id = '3';
        params.webproduct = '6';
        params.locale = locale;
        params.product_name = window.FlyerlineConfig.product_name;

        if( customizedProductId !== null )
        {
            params.customizedproductid = customizedProductId;
        }

        return this.get('personalization/computeUrl', params);
    }

    get (endpoint, data = {}, useFetch = false) {
        const params = new URLSearchParams({'model': this.model})

        serializeParams(data, params)

        if (useFetch)
            return fetch(`${API_ENTRY}${endpoint}?` + params.toString());
        else
            return doGet(`${API_ENTRY}${endpoint}?` + params.toString());


        function serializeParams (data, params, propprefix="") {

            for (const prop of Object.keys(data)) {
                let propname = propprefix+"["+prop+"]"
                if( propprefix === ""){
                    propname = prop
                }
                if (typeof data[prop] === 'object') {
                    // recursion
                    serializeParams(data[prop], params, propname)
                } else if (!!data[prop]) {
                    params.append(propname,data[prop]);
                }
            }
        }
    }
}
